import { ButaWarnaSurat } from "../../components/SuratPenunjang/Helpers/ButaWarnaSurat";
import { GolonganDarahSurat } from "../../components/SuratPenunjang/Helpers/GolonganDarahSurat";
import { PekerjaanSurat } from "../../components/SuratPenunjang/Helpers/PekerjaanSurat";

export const SuratPenunjangStore = {
    namespaced: true,
    state() {
        return {
            CurrentlyPrintingLetter: false,
            TypeOfLetter: null,
            CurrentlyComposeLetter: false,
            CurrentlySavingLetter: false,
            KlinikInformation: null,
            PasienInformation: null,
            DokterInformation: null,
            RekamMedisIDFromPembayaran: null,
            TransKlinikIDFromPembayaran: null,
            PasienIDFromPembayaran: null,
            LetterNumber: null,
            LetterID: null,
            RekamMedisPenunjang: null,
            TataLaksanaPenunjang: [],
            RenderForm: false,
            AtPembayaranPage: false,
            BaseLetterNumber: null
        }
    },
    getters: {
        BASE_API_URL: (state, getters, rootState) => `${rootState.URL_API}`,
        API_URL: (state, getters, rootState) => `${rootState.URL_API}/surat-penunjang`,
        PekerjaanSurat: () => PekerjaanSurat(),
        GolonganDarahSurat: () => GolonganDarahSurat(),
        ButaWarnaSurat: () => ButaWarnaSurat(),
        TransKlinikID: (state, getters, rootState) => rootState.rekamMedis.transaksi.id,
        ShieldCheckIcon: () => {
            return `data:image/svg+xml;base64,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`
        }
    },
    actions: {
        ResetSuratPenunjangStore({ commit }) {
            commit('SetLetterID', null);
            commit('SetLetterNumber', null);
            commit('SetPasienIDFromPembayaran', null);
            commit('SetRekamMedisIDFromPembayaran', null);
            commit('SetTransKlinikIDFromPembayaran', null);
            commit('SetCurrentlySavingLetterMutation', false);
            commit('SetCurrentlyPrintingLetterMutation', false);
            commit('SetLetterMutation', false);
            commit('SetLetterTypeMutation', null);
            commit('SetKlinikInformationMutation', null);
            commit('SetPasienInformationMutation', null);
            commit('SetDokterInformationMutation', null);
            commit('SetRekamMedisPenunjangMutation', null);
            commit('SetTataLaksanaPenunjangMutation', null);
            commit('SetRenderFormMutation', false);
            commit('SetAtPembayaranPageMutation', false);
            commit('SetBaseLetterNumberMutation', null);
        },
        AddLetter({ getters, commit }, payload) {
            const { AddingLetter, LetterType } = payload;

            commit('SetLetterMutation', AddingLetter);
            commit('SetLetterTypeMutation', LetterType);
        }
    },
    mutations: {
        SetBaseLetterNumberMutation(state, payload = null) {
            state.BaseLetterNumber = payload;
        },
        SetAtPembayaranPageMutation(state, payload = false) {
            state.AtPembayaranPage = payload;
        },
        SetRenderFormMutation(state, payload = false) {
            state.RenderForm = payload;
        },
        SetRekamMedisPenunjang(state, payload = null) {
            state.RekamMedisPenunjang = payload;
        },
        SetLetterID(state, payload = null) {
            state.LetterID = payload;
        },
        SetLetterNumber(state, payload = null) {
            state.LetterNumber = payload;
        },
        SetPasienIDFromPembayaran(state, payload = null) {
            state.PasienIDFromPembayaran = payload;
        },
        SetRekamMedisIDFromPembayaran(state, payload = null) {
            state.RekamMedisIDFromPembayaran = payload;
        },
        SetTransKlinikIDFromPembayaran(state, payload = null) {
            state.TransKlinikIDFromPembayaran = payload;
        },
        SetCurrentlySavingLetterMutation(state, payload = false) {
            state.CurrentlySavingLetter = payload;
        },
        SetCurrentlyPrintingLetterMutation(state, payload = false) {
            this.commit('SET_LOADING', payload)

            state.CurrentlyPrintingLetter = payload;
        },
        SetLetterMutation(state, payload = false) {
            state.CurrentlyComposeLetter = payload;
        },
        SetLetterTypeMutation(state, payload = null) {
            state.TypeOfLetter = payload;
        },
        SetKlinikInformationMutation(state, payload) {
            if (payload) {
                const { nama_klinik, alamat, kota, foto_klinik } = payload
                const { nama } = kota
                state.KlinikInformation = {
                    KlinikName: nama_klinik,
                    KlinikAddress: alamat,
                    KlinikCity: nama,
                    KlinikIMG: foto_klinik || '/img/new_logo.png'
                };
            } else {
                state.KlinikInformation = null;
            }
        },
        SetDokterInformationMutation(state, payload) {
            if (payload) {
                const { nama, spesialisasi_id, nomor_sip } = payload
                state.DokterInformation = {
                    DokterName: nama,
                    DokterSpecialist: spesialisasi_id,
                    DokterSIP: nomor_sip,
                };
            } else {
                state.DokterInformation = null;
            }
        },
        SetPasienInformationMutation(state, payload) {
            if (payload) {
                const { nama, umur, nik, tanggal_lahir, jenis_kelamin, pekerjaan, tinggi_badan, berat_badan, suhu, tensi_sistole, tensi_diastole, nadi, respirasi, lingkar_perut, imt, nomor_rekam_medis, anamnesa, email, nomor_hp, alamat_rumah, rt, rw, kelurahan, kecamatan, provinsi, kota, status_perkawinan, nomor_polis_asuransi, nomor_member_asuransi, hubungan_pasien, alergi_kondisi_khusus, nomor_rekam_medis_manual, nama_penanggung_jawab, nomor_hp_penaggung_jawab, } = payload
                state.PasienInformation = {
                    PasienName: nama,
                    PasienAge: umur,
                    PasienNIK: nik,
                    PasienDateBirth: tanggal_lahir,
                    PasienSex: jenis_kelamin,
                    PasienJob: pekerjaan,
                    PasienHeight: tinggi_badan,
                    PasienWeight: berat_badan,
                    PasienTemperature: suhu,
                    PasienSystole: tensi_sistole,
                    PasienDiastole: tensi_diastole,
                    PasienPulse: nadi,
                    PasienRespiration: respirasi,
                    PasienPerimeter: lingkar_perut,
                    PasienIMT: imt,
                    PasienMRN: nomor_rekam_medis,
                    PasienAnamnesa: anamnesa,
                    PasienEmail: email,
                    PasienPhone: nomor_hp,
                    PasienAddress: `${alamat_rumah || ''} ${rt || ''} ${rw || ''} ${kelurahan && kelurahan.nama || ''} ${kecamatan && kecamatan.nama || ''} ${provinsi && provinsi.provinsi_name || ''} ${kota && kota.nama || ''}`,
                    PasienRT: rt,
                    PasienRW: rw,
                    PasienKelurahan: kelurahan,
                    PasienKecamatan: kecamatan,
                    PasienProvinsi: provinsi,
                    PasienCity: kota,
                    PasienMaritalStatus: status_perkawinan,
                    PasienInsuranceNumber: nomor_polis_asuransi,
                    PasienInsuranceMemberNumber: nomor_member_asuransi,
                    PasienAllergy: alergi_kondisi_khusus,
                    PasienMRNManual: nomor_rekam_medis_manual,
                    PasienGuarantorName: nama_penanggung_jawab,
                    PasienGuarantorRelationship: hubungan_pasien,
                    PasienGuarantorPhone: nomor_hp_penaggung_jawab,
                };
            } else {
                state.PasienInformation = null;
            }
        },
        SetRekamMedisPenunjangMutation(state, payload) {
            if (payload) {
                const { kode_diagnosa_primary, kode_diagnosa, anamnesa } = payload
                state.RekamMedisPenunjang = {
                    RekamMedisPenunjangDiagnosisPrimary: kode_diagnosa_primary,
                    RekamMedisPenunjangDiagnosis: kode_diagnosa,
                    Anamnesa: anamnesa
                };
            } else {
                state.RekamMedisPenunjang = null;
            }
        },
        SetTataLaksanaPenunjangMutation(state, payload = []) {
            state.TataLaksanaPenunjang = payload
        }
    }
};
